import { useState } from "react";
import {
  getWheelRaffleErrorMessage,
  useLazySearchRafflesQuery,
} from "entities/wheel-raffle";
import { getErrorStatusCode } from "shared/utils";

const ID_PATTERN = /^\d+$/;

// Бэк решает так же: только цифры — id, иначе invite-код.
const isInviteCode = (query: string): boolean => !ID_PATTERN.test(query);

// Ищем по submit, а не на ввод: по коду лимит 5 запросов в минуту.
export const useRaffleSearch = () => {
  const [query, setQuery] = useState("");
  const [activeQuery, setActiveQuery] = useState<string | null>(null);
  const [search, result] = useLazySearchRafflesQuery();

  const submit = () => {
    const trimmed = query.trim();
    if (!trimmed) return;
    setActiveQuery(trimmed);
    // Повтор того же запроса берём из кеша, не тратя лимит.
    search(trimmed, true);
  };

  const clear = () => {
    setQuery("");
    setActiveQuery(null);
  };

  // 404 — это «ничего не нашлось», а не ошибка.
  const isNotFound = getErrorStatusCode(result.error) === 404;

  return {
    query,
    setQuery,
    submit,
    clear,
    isActive: activeQuery !== null,
    results: (activeQuery && result.currentData) || [],
    // Код из поиска нужен, чтобы вступить в найденный приватный розыгрыш.
    inviteCode: activeQuery && isInviteCode(activeQuery) ? activeQuery : null,
    isSearching: result.isFetching,
    errorMessage: isNotFound ? null : getWheelRaffleErrorMessage(result.error),
  };
};

export type RaffleSearch = ReturnType<typeof useRaffleSearch>;
